/**
 * Check if a site setting field contains a truthy value.
 * Supports various formats: "1", "y", "Y", "yes", "true", true, 1
 * 
 * @param siteJson - Site settings object
 * @param field - Field name to check
 * @returns boolean
 */
export function getYesNo(
  json, 
  field
) {
  if (!json || !field) {
    return false;
  }
  
  if (!(field in json)) {
    return false;
  }
  
  const value = json[field];
  
  // Check for truthy values
  const truthyValues = ['1', 'y', 'Y', 'yes', 'YES', 'true', 'TRUE', true, 1];
  return truthyValues.includes(value);
}